<template>
  <div>
    <a-modal
        v-drag-modal
        wrap-class-name="custom-modal-wrap" v-model="localVisible" width="750px" :confirmLoading="loading"
        :maskClosable="false" :destroyOnClose="true" @cancel="cancel" @ok="confirm"
>
      <div slot="title">{{ innerForm.id ? '编辑产品信息' : '新增产品信息' }}</div>
      <!--      <div style="height: 80vh; overflow-y: auto; overflow-x: hidden">-->
      <div style="max-height: 65vh; overflow-y: auto;border: 1px solid #277fd0 ; overflow-x: hidden;padding: 10px;margin: -10px">

        <a-form-model
            ref="form"
            :model="innerForm"
            :rules="rules"
            :label-col="{ span: 4, md: 8 }"
            :wrapper-col="{ span: 20, md: 16 }"
>
          <a-row :gutter="12">
            <a-divider orientation="left" id="basic-information">
              基本信息
            </a-divider>
            <a-col :span="24" :md="12">
              <a-form-model-item prop="types" label="新增类型">
                <a-select placeholder="选择新增类型" v-model="innerForm.types" style="width: 100%" allowClear>
                  <a-select-option value="product">
                    产品
                  </a-select-option>
                  <a-select-option value="material">
                    原料
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :md="12">
              <a-form-model-item prop="barcode" label="条形码">
                <a-input v-model="innerForm.barcode" />
                <!-- <a-input-search v-model="innerForm.barcode">
                  <a-button slot="enterButton" type="primary" @click.native="getCode">生成条形码</a-button>
                </a-input-search> -->
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :md="12">
              <a-form-model-item prop="number" label="产品编号">
                <a-input v-model="innerForm.number" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :md="12">
              <a-form-model-item prop="name" label="产品名称">
                <a-input v-model="innerForm.name" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :md="12">
              <a-form-model-item prop="spec" label="规格">
                <a-input v-model="innerForm.spec" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :md="12">
              <a-form-model-item prop="product_brand" label="品牌">
                <a-input v-model="innerForm.product_brand" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :md="12">
              <a-form-model-item prop="category" label="分类">
                <a-select v-model.number="innerForm.category" style="width: 100%" :allowClear="true">
                  <a-select-option
                      v-for="item of classificationItems"
                      :key="item.id"
                      :value="item.id"
>{{ item.name }}
                  </a-select-option>
                </a-select>
                <a-button
                    type="primary"
                    @click="onAdd"
>
                  <a-icon type="plus" />
                  新增分类
                </a-button>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :md="12">
              <a-form-model-item prop="unit" label="单位">
                <a-select v-model.number="innerForm.unit" :allowClear="true">
                  <a-select-option
                      v-for="item of unitItems"
                      :key="item.id"
                      :value="item.id"
>{{ item.name }}
                  </a-select-option>
                </a-select>
                <a-button
                    type="primary"
                    @click="onAdd1"
>
                  <a-icon type="plus" />
                  新增单位
                </a-button>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :md="12">
              <a-form-model-item prop="standards" label="执行标准">
                <a-input v-model="innerForm.standards" />
              </a-form-model-item>
            </a-col>
            <!-- <a-col :span="24" :md="12">
              <a-form-model-item prop="enable_shelf_life" label="启用保质期">
                <a-switch
                  checked-children="启用"
                  un-checked-children="禁用"
                  v-model="form.enable_shelf_life"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :md="12">
              <a-form-model-item prop="shelf_life_days" label="保质期天数">
                <a-input v-model="form.shelf_life_days" suffix="天" />
              </a-form-model-item>
            </a-col> -->
            <a-col :span="24" :md="12">
              <a-form-model-item
                  prop="shelf_life_warning_days"
                  label="保质期预警天数"
>
                <a-input-number style="width: 180px; margin-right: 20px" v-model="innerForm.shelf_life_warning_days" />
                <span>天</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :md="12">
              <a-form-model-item prop="enable_batch_control" label="启用批次控制">
                <a-switch
                    checked-children="启用"
                    un-checked-children="禁用"
                    v-model="innerForm.enable_batch_control"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :md="12">
              <a-form-model-item prop="shelf_life_days" label="保质期">
                <div style="display: flex; justify-content: flex-end;">
                  <a-input-number style="width: 150px; margin-right: 10px" v-model="innerForm.shelf_life_days" />
                <a-select placeholder="选择保质期单位" v-model="innerForm.period_unit" style="width: 80%" allowClear>
                    <a-select-option value="天">
                      天
                    </a-select-option>
                    <a-select-option value="月">
                      月
                    </a-select-option>
                    <a-select-option value="年">
                      年
                    </a-select-option>
                  </a-select>
                </div>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :md="12">
              <a-form-model-item prop="is_active" label="状态">
                <a-switch v-model="innerForm.is_active" checked-children="激活" un-checked-children="冻结" />
              </a-form-model-item>
            </a-col>
            <a-col v-if="innerForm.id" :span="24">
              <a-form-model-item
                  prop="remark"
                  label="关联原材料"
                  :label-col="{ span: 4, md: 3 }"
                  :wrapper-col="{ span: 20, md: 21 }"
              >
                <a-select
                    mode="multiple"
                    v-model="innerForm.association"
                    show-search
                    :filter-option="false"
                    :loading="materialLoading"
                    :max-tag-count="associationMaxTagCount"
                    :max-tag-text-length="10"
                    :max-tag-placeholder="omittedMaterialsPlaceholder"
                    placeholder="选择关联原材料（支持搜索名称）"
                    allowClear
                    @search="handleMaterialSearch"
                    @popupScroll="handleMaterialScroll"
                >
                  <a-select-option
                      v-for="val in materialList"
                      :key="val.id"
                      :value="val.id.toString()"
                      :label="val.name"
                  >
                    {{ val.name }} <span style="color: #bbb">({{ val.id }})</span>
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :md="12">
              <a-form-model-item prop="remark" label="备注">
                <a-textarea v-model="innerForm.remark" allowClear />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-divider orientation="left" id="price-management">
              价格管理
            </a-divider>
            <a-col :span="24" :md="12">
              <a-form-model-item prop="purchase_price" label="采购价(元)">
                <a-input-number v-model="innerForm.purchase_price" style="width: 100%" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :md="12">
              <a-form-model-item prop="retail_price" label="零售价(元)">
                <a-input-number v-model="innerForm.retail_price" style="width: 100%" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :md="12">
              <a-form-model-item prop="level_price1" label="等级价一(元)">
                <a-input-number v-model="innerForm.level_price1" style="width: 100%" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :md="12">
              <a-form-model-item prop="level_price2" label="等级价二(元)">
                <a-input-number v-model="innerForm.level_price2" style="width: 100%" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :md="12">
              <a-form-model-item prop="level_price3" label="等级价三(元)">
                <a-input-number v-model="innerForm.level_price3" style="width: 100%" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-divider orientation="left" id="graphic-information">
              附件
            </a-divider>
            <a-col :span="24" :md="24">
              <Upload :ID_image="innerForm.images" :count="5" @handleChange="handleChange" />
              <!-- <a-upload
                :action="uploadUrl"
                list-type="picture-card"
                :headers="{ 'X-CSRFToken': Cookies.get('csrftoken'), Authorization: 'Bearer ' + Cookies.get('access') }"
                :file-list="innerForm.images"
                @preview="handlePreview"
                @change="handleChange"
                :before-upload="beforeUpload"
                name="file">
                <div>
                  <a-icon type="plus" />
                  <div class="ant-upload-text"></div>
                </div>
              </a-upload>
              <a-modal
                :visible="previewVisible"
                :footer="null"
                @cancel="handleCancel"
              >
                <img alt="example" style="width: 100%" :src="previewImage" />
              </a-modal> -->
            </a-col>
            <a-col :span="24" :md="24">
              <a-textarea
                  placeholder="产品详细介绍"
                  :rows="4"
                  v-model="innerForm.description"
              />
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-divider orientation="left" id="beginning-inventory">
              期初库存
            </a-divider>
            <a-col :span="24" :md="24">
              <a-table
                  rowKey="id"
                  :columns="columns"
                  :data-source="innerWarehouseItems"
                  :loading="loading"
                  :pagination="false"
                  style="width: 100%"
>
                <div slot="initial_quantity" slot-scope="value, item">
                  <div v-if="!!innerForm.enable_batch_control">
                    <a-input :value="item.initial_quantity" disabled style="width:75%;" />
                    <a-button @click="chooseBatch(item)">批</a-button>
                  </div>
                  <a-input-number v-else
                                  :value="item.initial_quantity"
                                  :min="0"
                                  @change="(value) => changeQuantity(value, item)"
/>
                </div>
              </a-table>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-divider orientation="left" id="inventory-warning">
              库存预警
            </a-divider>
            <a-col :span="24" :md="12">
              <a-form-model-item prop="enable_inventory_warning" label="启用库存警告">
                <a-switch
                    checked-children="启用"
                    un-checked-children="禁用"
                    v-model="innerForm.enable_inventory_warning"
/>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :md="12" v-if="!!innerForm.enable_inventory_warning">
              <a-form-model-item prop="inventory_upper" label="库存上限">
                <a-input-number v-model="innerForm.inventory_upper" style="width: 100%" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :md="12" v-if="!!innerForm.enable_inventory_warning">
              <a-form-model-item prop="inventory_lower" label="库存下限">
                <a-input-number v-model="innerForm.inventory_lower" style="width: 100%" />
              </a-form-model-item>
            </a-col>
            <!-- <a-col :span="24" :md="12">
              <a-form-model-item
                prop="inventory_warning_upper_limit"
                label="库存预警上限">
                <a-input-number
                  v-model="form.inventory_warning_upper_limit"
                  style="width: 100%" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24" :md="12">
              <a-form-model-item
                prop="inventory_warning_lower_limit"
                label="库存预警下限">
                <a-input-number
                  v-model="form.inventory_warning_lower_limit"
                  style="width: 100%"/>
              </a-form-model-item>
            </a-col> -->
          </a-row>
        </a-form-model>
      </div>
      <!-- 批次 -->
      <a-modal
          :title="batchTitle"
          v-model="batchVisible"
          width="750px"
          cancelText="关闭"
          :maskClosable="false"
          @cancel="batchVisible=false"
          @ok="confirmChoosed"
>
        <div style="margin-bottom: 16px">
          <a-button type="primary" icon="plus" style="margin: 0 8px;" @click="addLine">添加</a-button>
        </div>
        <a-table
            rowKey="id"
            :columns="columnsBatch"
            :data-source="batchItems"
            :pagination="false"
            style="width: 100%"
>
          <div slot="initial_quantity" slot-scope="value, item">
            <a-input-number
                :value="item.initial_quantity"
                :min="1"
                @change="(value) => changeQuantityBatch(value, item, 'initial_quantity')"
/>
          </div>
          <div slot="number" slot-scope="value, item">
            <a-input
                :value="item.number"
                @change="(e) => changeQuantityBatch(e, item, 'number')"
/>
          </div>
          <div slot="production_date" slot-scope="value, item">
            <a-date-picker
                :value="item.production_date"
                valueFormat="YYYY-MM-DD"
                @change="(value) => changeQuantityBatch(value, item, 'production_date')"
/>
          </div>
          <div slot="action" slot-scope="value,item">
            <a-button icon="minus" @click="removeLine(item)"></a-button>
          </div>
        </a-table>
      </a-modal>
      <!-- 分类 -->
      <a-modal v-model="categoryVisible" title="新增产品分类" :maskClosable="false" @cancel="categoryVisible = false"
               @ok="addClass"
>
        <div>
          <a-form-model ref="categoryForm" :model="categoryForm" :rules="categoryRules" :label-col="{ span: 4 }"
                        :wrapper-col="{ span: 16 }"
>
            <a-form-model-item prop="name" label="分类名称">
              <a-input v-model="categoryForm.name" />
            </a-form-model-item>
            <a-form-model-item prop="remark" label="备注">
              <a-input v-model="categoryForm.remark" allowClear />
            </a-form-model-item>
          </a-form-model>
        </div>
      </a-modal>
      <!-- 单位 -->
      <a-modal v-model="unitVisible" title="新增产品单位" :maskClosable="false" @cancel="unitVisible = false"
               @ok="addUnit"
>
        <div>
          <a-form-model ref="unitForm" :model="unitForm" :rules="unitRules" :label-col="{ span: 4 }"
                        :wrapper-col="{ span: 16 }"
>
            <a-form-model-item prop="name" label="单位名称">
              <a-input v-model="unitForm.name" />
            </a-form-model-item>
            <a-form-model-item prop="remark" label="备注">
              <a-input v-model="unitForm.remark" allowClear />
            </a-form-model-item>
          </a-form-model>
        </div>
      </a-modal>
    </a-modal>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import Upload from '../../../components/Upload/index1'
import {goodsInformationCreate, goodsInformationUpdate, goodsInformationList, goodsClassificationCreate, goodsUnitCreate} from '@/api/goods'

export default {
  name: 'FormModal',
  components: {
    Upload
  },
  model: {prop: 'visible', event: 'cancel'},
  props: {
    visible: { type: Boolean, default: false },
    form: { type: Object, default: () => ({}) },
    warehouseItems: { type: Array, default: () => [] },
    classificationItems: { type: Array, default: () => [] },
    unitItems: { type: Array, default: () => [] },
  },
  data() {
    return {
      categoryForm: {},
      unitForm: {},
      uploadUrl: process.env.VUE_APP_NEW_URL + '/comapi/UploadApi',
      Cookies,
      batchTitle: '管理批次',
      batchVisible: false,
      unitVisible: false,
      loading: false,
      localVisible: this.visible,
      innerForm: this.form,
      innerWarehouseItems: this.warehouseItems,
      associationMaxTagCount: 6,
      materialList: [],
      materialPage: 1,
      materialTotal: 0,
      materialKeyword: '',
      materialLoading: false,
      materialSearchTimer: null,
      columns: [
        {
          title: "仓库",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "初始库存",
          dataIndex: "initial_quantity",
          key: "initial_quantity",
          scopedSlots: {customRender: "initial_quantity"},
        },
      ],
      isKeepAdd: false,
      categoryRules: {
        name: [{required: true, message: '请输入分类名称', trigger: 'blur'},
          {max: 64, message: "超出最大长度 (64)", trigger: "blur"},]
      },
      unitRules: {
        name: [{required: true, message: '请输入单位名称', trigger: 'blur'},
          {max: 64, message: "超出最大长度 (64)", trigger: "blur"},]
      },
      categoryVisible: false,
      rules: {
        types: [
          {required: true, message: "请选择新增类型", trigger: "change"}
        ],
        name: [
          {required: true, message: "请输入产品名称", trigger: "blur"},
        ],
        number: [
          {required: true, message: "请输入产品编号", trigger: "blur"},
        ],
        shelf_life_days: [
          {required: true, message: "请输入保质期", trigger: "blur"},
        ],
        period_unit: [
          {required: true, message: "请选择保质期单位", trigger: "change"}
        ]
      },
      previewVisible: false,
      previewImage: "",
      columnsBatch: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          customRender: (value, item, index) => {
            return index + 1
          },
        },
        {
          title: "编号",
          dataIndex: "number",
          key: "number",
          scopedSlots: {customRender: "number"},
        },
        {
          title: "初始库存",
          dataIndex: "initial_quantity",
          key: "initial_quantity",
          scopedSlots: {customRender: "initial_quantity"},
        },
        {
          title: "生产日期",
          dataIndex: "production_date",
          key: "production_date",
          scopedSlots: {customRender: "production_date"},
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: {customRender: 'action'},
          width: '80px'
        },
      ],
      curWarehouse: {},
      batchItems: []
    };
  },
  watch: {
    visible(v) {
      this.localVisible = v
      if (v) {
        this.materialList = []
        this.materialPage = 1
        this.materialTotal = 0
        this.materialKeyword = ''
        this.loadMaterials(false)
      }
    },
    form(v) { this.innerForm = v; },
    warehouseItems(v) { this.innerWarehouseItems = v; },
    'innerForm.association': {
      handler(newVal) {
        // 1. 确保是数组
        if (!Array.isArray(newVal)) {
          this.$set(this.innerForm, 'association', []);
          return;
        }

        // 2. 确保每个id是字符串
        const normalized = newVal.map(id => String(id));
        if (normalized.some((id, index) => id !== newVal[index])) {
          // 如果存在类型不一致的项，触发更新
          this.$set(this.innerForm, 'association', normalized);
        }
      },
      deep: true,
      immediate: true // 初始化时立即触发
    },
  },
  methods: {
    omittedMaterialsPlaceholder() {
      const all = Array.isArray(this.innerForm.association) ? this.innerForm.association : []
      const omitted = all.slice(this.associationMaxTagCount)
      const map = {}
      this.materialList.forEach(it => { map[String(it.id)] = it.name })
      const names = omitted.map(id => map[String(id)] || String(id))
      const h = this.$createElement
      return h(
          'a-tooltip',
          { props: { placement: 'top', title: names.join('、') || '—' } },
          [`+ ${omitted.length} 项`]
      )
    },
    loadMaterials(isLoadMore) {
      if (!isLoadMore) {
        this.materialPage = 1
      }
      this.materialLoading = true
      const params = { page: this.materialPage, page_size: 50, is_active: true, types: 'material' }
      if (this.materialKeyword) params.search = this.materialKeyword
      goodsInformationList(params).then(data => {
        this.materialTotal = data.count
        const incoming = data.results || []
        if (isLoadMore) {
          // 合并时去重（防止搜索清空后重复）
          const existingIds = new Set(this.materialList.map(i => i.id))
          this.materialList = this.materialList.concat(incoming.filter(i => !existingIds.has(i.id)))
        } else {
          // 首屏：把已选中但不在首屏的项补到列表头，防止选中值显示空白
          const selected = Array.isArray(this.innerForm.association) ? this.innerForm.association : []
          const incomingIds = new Set(incoming.map(i => String(i.id)))
          const missing = selected.filter(id => !incomingIds.has(String(id)))
          if (missing.length > 0) {
            goodsInformationList({ page: 1, page_size: missing.length + 10, search: missing[0], types: 'material', is_active: true }).then(extra => {
              const extraHits = (extra.results || []).filter(i => missing.includes(String(i.id)))
              this.materialList = [...extraHits, ...incoming]
            }).catch(() => {
              this.materialList = incoming
            })
          } else {
            this.materialList = incoming
          }
        }
      }).finally(() => {
        this.materialLoading = false
      })
    },
    handleMaterialSearch(val) {
      this.materialKeyword = val
      clearTimeout(this.materialSearchTimer)
      this.materialSearchTimer = setTimeout(() => {
        this.materialPage = 1
        this.loadMaterials(false)
      }, 300)
    },
    handleMaterialScroll(e) {
      const target = e.target
      if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 20) {
        if (this.materialList.length < this.materialTotal && !this.materialLoading) {
          this.materialPage += 1
          this.loadMaterials(true)
        }
      }
    },
    onAdd() {
      this.categoryVisible = true;
      this.categoryForm = {}
    },
    onAdd1() {
      this.unitVisible = true;
      this.unitForm = {}
    },
    addClass() {
      this.$refs.categoryForm.validate(valid => {
        if (valid) {
          goodsClassificationCreate(this.categoryForm).then(data => {
            this.$message.success('新增成功');
            this.categoryVisible = false;
            this.$emit('getClassInfo')
          });
        }
      });
    },
    addUnit() {
      this.$refs.unitForm.validate(valid => {
        if (valid) {
          goodsUnitCreate(this.unitForm).then(data => {
            this.$message.success('新增成功');
            this.unitVisible = false;
            this.$emit('getUnitInfo')
          });
        }
      });
    },
    chooseBatch(item) {
      this.batchTitle = '管理批次-' + item.name;
      this.curWarehouse = item;
      if (item.batch_items) {
        this.batchItems = item.batch_items;
      } else {
        this.batchItems = [
          {
            key: 'uni1',
            number: '',
            initial_quantity: 1,
            production_date: null,
          }
        ];
      }
      this.batchVisible = true;
    },
    confirmChoosed() {
      let ifHasEmpty = false;
      let sumAmount = 0;
      this.batchItems.map(item => {
        sumAmount += item.initial_quantity
        if (!item.number || !item.initial_quantity || !item.production_date) {
          ifHasEmpty = true;
        }
      })
      if (ifHasEmpty) {
        this.$message.warn('请将批次信息填写完整!');
        return
      }
      let tmp = {...this.curWarehouse, ...{batch_items: this.batchItems, initial_quantity: sumAmount}}
      this.innerWarehouseItems = this.$functions.replaceItem(this.innerWarehouseItems, tmp);
      this.batchVisible = false;
    },
    addLine() {
      const {batchItems} = this;
      const newData = {
        key: 'uni' + batchItems.length + 1,
        number: '',
        initial_quantity: 1,
        production_date: null,
      };
      this.batchItems = [...batchItems, newData];
    },
    removeLine(item) {
      this.batchItems = this.$functions.removeItemBatch(this.batchItems, item);
    },
    changeQuantity(value, item) {
      // 保留用户输入的值（包括 0），不做 || 0 转换
      item['initial_quantity'] = value;
      this.innerWarehouseItems = this.$functions.replaceItem(this.innerWarehouseItems, item);
    },
    changeQuantityBatch(e, item, pro) {
      if (pro === 'number') {
        item[pro] = e.target && e.target.value;
      } else {
        item[pro] = e;
      }
      this.batchItems[item.key - 1] = item;
    },
    handleChange(val) {
      this.$set(this.innerForm, 'images', val);
      this.$forceUpdate();
    },
    beforeUpload() {
    },
    handleCancel() {
      this.previewVisible = false;
    },
    confirm() {
      // 提取 URL 字符串数组用于提交，不修改 innerForm.images（保持 fileList 格式，避免 Upload validator 报错）
      let images = (this.innerForm.images || [])
          .filter((item) => (item.response && item.response.code === 200) || (item.status && item.status === 'done'))
          .map((item) => {
            if (item.url) return item.url;
            return item.response.data.file_url;
          });
      let inventory_items = this.innerWarehouseItems && this.innerWarehouseItems
        .filter(item => {
          // 提交条件：
          // 1. 原本有库存记录的仓库（即使用户清空了，也要提交更新为0）
          // 2. 用户新设置了期初库存的仓库（initial_quantity 有值）
          return item._hasInventoryRecord || (item.initial_quantity !== undefined && item.initial_quantity !== null);
        })
        .map(item => {
          return {
            warehouse: item.id,
            initial_quantity: item.initial_quantity !== undefined && item.initial_quantity !== null ? item.initial_quantity : 0,
            batch_items: this.innerForm.enable_batch_control ? (item.batch_items || []) : []
          }
        })
      // 用独立的 formatData 提交，不污染 innerForm.images
      // 过滤掉后端不存在的计算字段
      let formatData = {
        ...this.innerForm,
        shelf_life_days: this.innerForm.shelf_life_days * 1,
        images,
        inventory_items,
      }
      // 删除后端计算字段，避免提交时报错
      delete formatData.trace_status
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          let func = this.innerForm.id ? goodsInformationUpdate : goodsInformationCreate;
          func(formatData).then(data => {
            this.$message.success(this.innerForm.id ? '修改成功' : '新增成功');

            // 更新本地状态：initial_quantity 为 0 的仓库应该显示为空（不是0）
            if (data.inventory_items) {
              const inventoryMap = {};
              data.inventory_items.forEach(inv => {
                inventoryMap[inv.warehouse] = inv;
              });
              this.innerWarehouseItems.forEach(item => {
                const inv = inventoryMap[item.id];
                if (inv) {
                  // 后端返回了该仓库，但如果 initial_quantity 为 0，显示为空
                  const qty = inv.initial_quantity;
                  item.initial_quantity = (qty === 0 || qty === null) ? undefined : qty;
                  item._hasInventoryRecord = true;
                } else {
                  // 后端没有返回该仓库，说明没有库存记录
                  item.initial_quantity = undefined;
                  item._hasInventoryRecord = false;
                }
              });
            }

            this.$emit(this.innerForm.id ? 'update' : 'create', data);
            this.cancel();
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },
    cancel() {
      this.$emit('cancel', false);
      this.$refs.form.resetFields();
      this.materialKeyword = '';
    },
  }
}
</script>

<style scoped>
</style>
